/**
 * Which connected player's client an admin preview plays on (the Effects and
 * Cinematics tabs).
 */

import { useMemo } from 'react';
import type { Player } from '@swtorbit/shared-socket-events';

export interface PreviewTargetSelectProps {
  players: Player[];
  value: string;
  onChange: (playerId: string) => void;
}

export function PreviewTargetSelect({ players, value, onChange }: PreviewTargetSelectProps) {
  const connected = useMemo(() => players.filter((p) => p.status === 'connected'), [players]);
  return (
    <div className="preview-target-row bg-space bg-o-50 border-md border-blue-light rounded-base p-sm mb-sm d-flex align-items-center gap-sm flex-wrap">
      <label className="d-flex align-items-center gap-xs">
        <span className="label-text">Preview on:</span>
        <select className="select" value={value} onChange={(e) => onChange(e.target.value)}>
          <option value="">— select a player —</option>
          {connected.map((p) => (
            <option key={p.playerId} value={p.playerId}>
              {p.characterName || p.playerId}
            </option>
          ))}
        </select>
      </label>
      {connected.length === 0 && <span className="text-amber fs-sm">No players connected yet</span>}
    </div>
  );
}
